<a [href]="url" class="fs-xs text-primary" *ngIf="imageUrl">
  <app-image
    variant="logo"
    [altText]="altText"
    [width]="width"
    [height]="height"
    [image]="imageUrl"></app-image>
</a>
